<template>
  <div>
    <b-card class="mt-3" body-class="py-4 px-3">
      <div class="d-flex justify-content-between">
        <b-button class="next" variant="warning" @click="openModal">
          Add Type
        </b-button>
        <b-form-group class="m-0">
          <b-input-group>
            <b-form-input
              v-model="keyword"
              placeholder="Search..."
              @change="$refs.table.refresh()"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <br />
      <b-row v-show="!items.length">
        <b-col>
          <div align="center">
            <img src="@/assets/icon-no-invoice.png" />
          </div>
        </b-col>
      </b-row>
      <b-table
        ref="table"
        v-show="items.length"
        :items="fetchType"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        striped
        responsive
      >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
        </template>

        <template #cell(typeName)="{ item }">
          {{ item.typeName }}
        </template>

        <template #cell(action)="{ item }">
          <b-link class="mr-2" @click="goToEdit(item.id)">
            <fa-icon class="text-muted" icon="edit" />
          </b-link>
          <b-link @click="goToDelete(item.id)">
            <fa-icon class="text-muted" icon="trash" />
          </b-link>
        </template>
      </b-table>
      <div class="d-flex justify-content-between">
        <div>
          <span>Show</span>
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
            @change="$refs.table.refresh()"
            class="page-option ml-2 mr-2 w-auto"
            size="sm"
          />
          <span>Entries</span>
        </div>
        <div>
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            pills
            hide-goto-end-buttons
            @input="$refs.table.refresh()"
          />
          <span class="show-entries mr-auto">
            {{
              `Show ${
                totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1
              } to ${
                totalRows > currentPage * perPage
                  ? currentPage * perPage
                  : totalRows
              } of ${totalRows} entries`
            }}
          </span>
        </div>
      </div>
    </b-card>
    <modal-edit-type :typeData="typeData" @refresh="$refs.table.refresh()" />
    <modal-new-type @refresh="$refs.table.refresh()" />
    <modal-delete-type @delete="deleteType" />
  </div>
</template>

<script>
import api from '@/api'
import ModalNewType from './ModalNewType.vue'
import ModalEditType from './ModalEditType.vue'
import ModalDeleteType from './ModalDeleteType.vue'
export default {
  components: { ModalNewType, ModalEditType, ModalDeleteType },
  data: () => ({
    keyword: '',
    sortBy: '',
    currentPage: 1,
    perPage: 10,
    totalRows: 0,
    totalPage: 0,
    fields: [
      {
        key: 'no',
        label: 'No',
        tdClass: 'text-center',
        thClass: 'text-center'
      },
      {
        key: 'typeName',
        label: 'Type Name',
        tdClass: 'text-center',
        thClass: 'text-center',
        sortable: false
      },
      {
        key: 'action',
        label: 'Action',
        tdClass: 'text-center',
        thClass: 'text-center'
      }
    ],
    items: [],
    pageOptions: [10, 20, 50, 100],
    typeData: {},
    candidateIdDeleted: null
  }),
  methods: {
    async fetchType() {
      const { data } = await api.budget.type({
        page: this.currentPage,
        pageSize: this.perPage,
        filters: `typeName@=*${this.keyword}`,
        sorts: this.sortBy
      })
      this.items = data.length !== 0 ? data.data : []
      this.totalRows = data.length !== 0 ? data.totalData : 0
      this.totalPage = data.totalPage

      this.items.map((v, i) => {
        if (i % 2 === 0) {
          v._rowVariant = 'warning'
        }
      })
      return this.items
    },
    openModal() {
      this.$bvModal.show('modal-new-type')
    },
    goToEdit(id) {
      this.fetchEditType(id)
      this.$bvModal.show('modal-edit-type')
    },
    goToDelete(id) {
      this.candidateIdDeleted = id
      this.$bvModal.show('modal-delete-type')
    },
    async deleteType() {
      try {
        await api.budget.deleteType(this.candidateIdDeleted)
        this.$bvToast.toast('Type successfully deleted.', {
          headerClass: 'd-none',
          solid: true,
          variant: 'success'
        })
        this.$refs.table.refresh()
        this.candidateIdDeleted = null
      } catch (error) {
        this.$nextTick(() => {
          this.$bvToast.toast(
            error.message ? error.message.messageEng : error.data.messageEng,
            {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            }
          )
        })
      }
    },
    async fetchEditType(id) {
      const { data } = id
        ? await api.budget.getType(id)
        : await api.budget.type()
      this.typeData = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
.col,
.col-2,
.col-3,
.col-6 {
  padding: 0 16px;
}
</style>
